import Swiper, { Navigation, Autoplay } from "swiper";
Swiper.use([Navigation, Autoplay]);

import { gsap } from "gsap/dist/gsap"; // 最小限の GSAP を読み込む
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"; // ScrollTrigger のみ個別インポート

gsap.registerPlugin(ScrollTrigger);

export function idxFunc() {
  //スライドダウン
  $(".slide-toggle").on("click", function () {
    $(this).next(".slide-content").slideToggle();
    $(this).toggleClass("open");
  });

  /** トップページ 雲 */
  const tl = gsap.timeline();
  const video = document.querySelector(".kumo");
  const topAbout = document.querySelector(".top-about");
  const heading = document.querySelector(".top-about__heading");
  const headingCopy = document.querySelector(".top-about__copy");
  const topAboutFead1 = document.querySelector(".fade1 span");
  const topAboutFead2 = document.querySelector(".fade2 span");
  const topAboutFead3 = document.querySelector(".fade3 span");
  const topAboutCloud1 = document.querySelector(".cloud1");
  const topAboutCloud2 = document.querySelector(".cloud2");
  const topAboutCloud3 = document.querySelector(".cloud3");
  const topAboutOdashiLine = document.querySelector(".odashi-line");
  const topAboutOdashi = document.querySelector(".odashi");

  // if (video) {
  //   video.pause();
  //   // ScrollTriggerを設定
  //   ScrollTrigger.create({
  //     trigger: video,
  //     start: "top 80%",
  //     markers: false,
  //     onEnter: () => {
  //       // 動画を再生
  //       video.currentTime = 2.5; // 2秒から再生
  //       video.play();
  //       //video.playbackRate = 1.5; // 再生速度を1.5倍に

  //       // 1.5秒後にフェードアウト
  //       setTimeout(() => {
  //         gsap.to(video, {
  //           opacity: 0,
  //           duration: 0.2, // フェードアウトの時間（秒）
  //           ease: "linear", // イージング（滑らかに消える）
  //         });
  //         // 見出し要素にクラスを追加
  //         heading.classList.add("disp");
  //         headingCopy.classList.add("disp");

  //         // tl.to(topAboutFead1, {
  //         //   opacity: 1,
  //         //   delay: 1,
  //         //   letterSpacing: "normal",
  //         //   onStart: () => {
  //         //     topAboutCloud1.classList.add("disp");
  //         //   },
  //         // })
  //         //   .to(topAboutFead2, {
  //         //     opacity: 1,
  //         //     letterSpacing: "normal",
  //         //     onStart: () => {
  //         //       topAboutCloud2.classList.add("disp");
  //         //     },
  //         //   })
  //         //   .to(topAboutFead3, {
  //         //     opacity: 1,
  //         //     letterSpacing: "normal",
  //         //     onStart: () => {
  //         //       topAboutCloud3.classList.add("disp");
  //         //       topAboutOdashiLine.classList.add("animation");
  //         //       topAboutOdashi.classList.add("animation");
  //         //     },
  //         //     onComplete: () => {
  //         //       setTimeout(() => {
  //         //         topAbout.classList.add("end");
  //         //       }, 2000);
  //         //     },
  //         //   });
  //         tl.to([topAboutFead1, topAboutFead2, topAboutFead3], {
  //           opacity: 1,
  //           letterSpacing: "normal",
  //           duration: 1.2,
  //           ease: "power2.out",
  //           stagger: 0, // 少しずつズラしたければここで調整
  //           onStart: () => {
  //             topAboutCloud1.classList.add("disp");
  //             topAboutCloud2.classList.add("disp");
  //             topAboutCloud3.classList.add("disp");
  //             topAboutOdashiLine.classList.add("animation");
  //             topAboutOdashi.classList.add("animation");
  //           },
  //           onComplete: () => {
  //             setTimeout(() => {
  //               topAbout.classList.add("end");
  //             }, 1200);
  //           },
  //         }, "+=0.2"); // heading表示後の待機時間
  //       }, 1200);
  //     },
  //     once: false,
  //   });
  // }


  //雲動画なしに変更
  if (heading && headingCopy && topAbout) {
    ScrollTrigger.create({
      trigger: topAbout,
      start: "top 80%", // 適宜調整
      once: true, // 一度だけ実行（リロードで再実行したい場合は false）
      onEnter: () => {
        heading.classList.add("disp");
        headingCopy.classList.add("disp");
    
        tl.to([topAboutFead1, topAboutFead2, topAboutFead3], {
          opacity: 1,
          letterSpacing: "normal",
          duration: 1.2,
          ease: "power2.out",
          stagger: 0,
          onStart: () => {
            topAboutCloud1.classList.add("disp");
            topAboutCloud2.classList.add("disp");
            topAboutCloud3.classList.add("disp");
            topAboutOdashiLine.classList.add("animation");
            topAboutOdashi.classList.add("animation");
          },
          onComplete: () => {
            setTimeout(() => {
              topAbout.classList.add("end");
            }, 1200);
          },
        }, "+=0.2");
      }
    });  
  }
}
